/*<-----------------imports------------------------->*/
import React from "react";
import "./company-card.css";
import { ModalLink } from "../modal/modal.component";
/*<-----------------imports------------------------->*/

export const Card = (props) => {
  return (
    <div className="card-container">
      <h1 className="head_1">{props.company.name}</h1>
      <h2 className="head_2">Package: {props.company.package}</h2>
      <h2 className="head_2">Job Title: {props.company.title}</h2>
      <a
        href={props.company.url}
        className="head_3"
        target="_blank"
        rel="noopener noreferrer"
      >
        {props.company.url}
      </a>
      <ModalLink
        className="modal"
        link={props.company.form}
        desc={props.company.desc}
      ></ModalLink>
    </div>
  );
};
